import React, { useState } from "react";
import { exportUsersData } from "../../../services/DashboardServices";
import { Tooltip } from "@mui/material";

const ExportUsersData = () => {
  const [downloading, setDownloading] = useState(false);
  const handleExportUsersData = () => {
    exportUsersData().then((res) => {
      if (res && res.data) {
        console.log("res", res);
        console.log(res.data);
        const a = document.createElement("a");
        a.href = res.data;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(res.data);
        setDownloading(false);
      } else {
        setDownloading(false);
      }
    });
  };
  return (
    <>
      {!downloading && (
        <Tooltip title="Export bulk user data to Excel">
          <button
            className="bg-[#415280] text-[#fff] px-3 py-[6px] rounded-md"
            onClick={() => {
              setDownloading(true);
              handleExportUsersData();
            }}
          >
            Export Users Data
          </button>
        </Tooltip>
      )}
      {downloading && (
        <div>
          <Tooltip
            title="
          Downloading Excel File 
          "
          >
            <button className="bg-[#415280] text-[#fff] px-3 py-[6px] rounded-md h-full">
              Downloading In Progress..
            </button>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default ExportUsersData;
